import { ReactElement, useMemo } from "react";
import { ValidGlobalSearchItemPersistedModel } from "../../Persistence/validation";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { SearchListItem } from "client/Features/Search/SearchListItem";
import { generateTrackingId } from "client/Misc/utils";
import { CommunityListItem } from "client/Features/Layout/TitleBar/GlobalSearch/Items/CommunityListItem";
import { useCommunityNavigationHandler } from "client/Features/Layout/TitleBar/GlobalSearch/Navigation/useCommunityNavigationHandler";
import { AppColorKind, AppColorViewModel } from "client/Api/Apps/common";
import { convertAppColor } from "../../Persistence/convertPersistedData";

export type CommunityItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Community>;
	navigationIndex: number;
	onRemove: () => void;
};

export const CommunityItemView = (props: CommunityItemViewProps): ReactElement => {
	const {
		item,
		navigationIndex,
		onRemove
	} = props;

	const {
		id,
		visibility,
		isCurrentUserMember,
		memberCount,
		name,
		color: persistedColor
	} = item.community;

	const color = useMemo(
		(): AppColorViewModel => persistedColor
			? convertAppColor(persistedColor)
			: { kind: AppColorKind.Primary },
		[persistedColor]
	);

	const executeHandler: () => void = useCommunityNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<SearchListItem
			onExecute={executeHandler}
			trackingId={generateTrackingId("community-item", `|${id}`)}
		>
			<CommunityListItem
				id={id}
				visibility={visibility}
				isCurrentUserMember={isCurrentUserMember}
				memberCount={memberCount}
				name={name}
				color={color}
				onRemove={onRemove}
				itemIndex={navigationIndex}
				tabIndex={-1}
				onExecute={executeHandler}
			/>
		</SearchListItem>
	);
};
CommunityItemView.displayName = "CommunityItemView";